<template>
  <v-dialog width="800" persistent v-model="isShow">
    <UploadGroupModal
      :isShow="isUploadModalShow"
      :id="selectedItemId"
      @close="isUploadModalShow = false"
    ></UploadGroupModal>
    <v-dialog width="400" persistent v-model="isAddModalShow">
      <v-card>
        <v-toolbar color="primary" dense dark>
          <v-toolbar-title>New Member</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon
            @click="
              isAddModalShow = false;
              hostKey = '';
            "
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-2">
          <!-- <v-text-field label="ID" v-model="hostKey"></v-text-field> -->
          <v-autocomplete
            prepend-icon="mdi-database-search"
            label="Person Selector (type name or id to search)"
            v-model="hostKey"
            :items="items"
            :loading="isLoading"
            :search-input.sync="searchStaff"
            item-text="name"
            item-value="hostKey"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="addMember">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card style="min-height: 300px">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
      <!--  <v-icon @click="download" class="mr-4" :disabled="!group.identity"
          >mdi-download</v-icon
        >
        <v-icon
          @click="upload"
          class="mr-4"
          :disabled="!group.identity || group.isSystem"
          >mdi-upload</v-icon
        >-->
        <v-icon @click="close">mdi-close</v-icon>
      </v-toolbar>
      <v-tabs v-model="tab">
        <v-tab>Details</v-tab>
        <v-tab :disabled="!group.identity">Memebers</v-tab>
      </v-tabs>
      <div v-if="tab == 0" class="mt-5">
        <v-row style="width: 95%" class="ml-5">
          <v-text-field
            label="Name"
            v-model="group.name"
            :disabled="group.isSystem"
          ></v-text-field>
        </v-row>
          <v-row style="width: 95%" class="ml-5">
          <v-text-field
            label="Management Person"
            v-model="group.parentDepartmentId"
            :disabled="group.isSystem"
            v-if="userProfile.isAdmin"
            hint="000001;000002;0000003"
          ></v-text-field>
        </v-row>
        <v-row style="width: 95%" class="ml-5">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save" :disabled="group.isSystem"
            >Save</v-btn
          >
        </v-row>
      </div>
      <div v-if="tab == 1">
        <v-data-table
          :headers="headers"
          :items="members"
          :loading="isTableLoading"
          item-key="identity"
          :options.sync="memberOptions"
          :server-items-length="totalItems"
        >
          <template v-slot:top>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="add">Add</v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon @click="del(item)" class="mr-2" :disabled="group.isSystem"
              >mdi-delete</v-icon
            >
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { userService } from "@/api/user-service";
import { mapGetters } from 'vuex';
import UploadGroupModal from "@/components/Modals/UploadGroupModal";

export default {
  name: "GroupEditor",
  props: { isShow: Boolean, group: Object },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  components: { UploadGroupModal },
  data: () => {
    return {
      isTableLoading: false,
      isLoading: false,
      isUploadModalShow: false,
      isAddModalShow: false,
      selectedItemId: "",
      search: "",
      memberOptions: { page: 1, itemsPerPage: 10 },
      totalItems: 0,
      title: "Create",
      tab: 0,
      hostKey: "",
      members: [],
      items: [],
      searchStaff: "",
      headers: [
        { text: "ID", value: "hostKey", width: "90%" },
        // { text: "Name", value: "name", width: "60%" },

        { text: "Actions", value: "actions" },
      ],
    };
  },
  methods: {
    close() {
      this.tab = 0;
      this.hostKey = "";
      this.$emit("close", "close");
    },
    capitalizeFirstLetter(str) {
      if (!str || str.length == 0) return "";
      const capitalized = str[0].charAt(0).toUpperCase() + str[0].slice(1);
      return capitalized;
    },
    async getMembers() {
      this.members = [];
      const { sortBy, sortDesc, page, itemsPerPage } = this.memberOptions;
      this.isTableLoading = true;
      let response = await userService.getUserByDept(
        this.group.isSystem ? this.group.name : this.group.identity,
        page,
        itemsPerPage,
        this.capitalizeFirstLetter(sortBy),
        sortDesc,
        this.group.isSystem
      );
      if (response.total > 0) {
        this.totalItems = response.total;
        this.members = response.result;
      }
      this.isTableLoading = false;
    },
    async save() {
      if (!this.group.name) {
        alert("Please enter a name");
        return;
      }
      
      if (!this.group.parentDepartmentId || this.group.parentDepartmentId == '')
      {
        this.group.parentDepartmentId = this.userProfile.hostKey
      }

      //let payload = { name: this.name }
      if (!this.group.identity) {
        let result = await userService.createGroup(this.group);
        this.$emit("save", result);
      } else {
        let result = await userService.updateGroup(this.group);
        this.$emit("save", result);
      }
    },
    async del(item) {
      //console.log(item)
      await userService.removeUser(this.group.identity, item.hostKey);
      this.getMembers();
    },
    async addMember() {
      if (this.hostKey) {
        await userService.addUser(this.group.identity, this.hostKey);
        this.isAddModalShow = false;
        this.hostKey = "";
        this.getMembers();
      }
    },
    add() {
      this.isAddModalShow = true;
    },
    download() {},
    upload() {
      this.selectedItemId = this.group.identity;
      this.isUploadModalShow = true;
    },
  },
  async mounted(){
    if (!this.userProfile)
      await this.$store.dispatch('getUserProfile')
  },
  watch: {
    group(val) {
      if (val.identity) {
        if (this.group.isSystem) this.title = "View " + this.group.name;
        else this.title = "Edit " + this.group.name;
      } else this.title = "Create";
    },
    tab(val) {
      if (val == 1) {
        this.getMembers();
      }
    },
    memberOptions: {
      handler() {
        this.getMembers();
      },
      deep: true,
    },
    searchStaff(val) {
      if (!val || val.indexOf(" - ") != -1) return;

      if (this.isLoading) return;

      this.isLoading = true;

      const url = process.env.VUE_APP_HOST;

      let auth = localStorage.getItem("scientia-session-authorization");

      let access_token = JSON.parse(auth).access_token;

      let headers = {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      };
      // Lazily load input items
      fetch(
        url +
          "api/Foundation/Staff?page=1&itemsPerPage=10&asc=true&searchItem=" +
          val,
        headers
      )
        .then((res) => res.json())
        .then((res) => {
          const { count, result } = res;
          this.count = count;
          this.items = result;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style>
</style>